(() => {
  const recent = new Map();
  let quoteTimer;
  function emit(name, detail = {}) {
    const data = { ...detail, language: document.documentElement.lang || 'en' };
    const key = name + JSON.stringify(data);
    if (Date.now() - (recent.get(key) || 0) < 1500) return;
    if (recent.size > 200) recent.clear();
    recent.set(key, Date.now());
    const consent = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    if (consent && typeof window.gtag === 'function') window.gtag('event', 'mxb_' + name, data);
    document.dispatchEvent(new CustomEvent('mxb:analytics', { detail: { name: 'mxb_' + name, data } }));
  }
  ['service_selected', 'quote_generated', 'cart_added', 'checkout_started'].forEach(name => {
    document.addEventListener('mxb:' + name, event => {
      const source = event.detail || {};
      const safe = {};
      ['service', 'delivery', 'currency', 'value'].forEach(key => { if (source[key] !== undefined) safe[key] = source[key]; });
      if (name === 'quote_generated') {
        clearTimeout(quoteTimer);
        quoteTimer = setTimeout(() => emit(name, safe), 800);
      } else emit(name, safe);
    });
  });
  const direct = document.querySelector('[data-direct-service]');
  if (direct) emit('service_view', { service: direct.dataset.directService });
  else if (document.querySelector('.es-wrap')) emit('service_page_view', { service: 'editorial' });
  else if (document.querySelector('.mx-wrapper')) emit('service_page_view', { service: 'cv-career' });
  window.addEventListener('pagehide', () => clearTimeout(quoteTimer), { once: true });
})();
